import { Seo } from "../components/Seo";
import { FadeUp } from "../components/Reveal";

const SECTIONS = [
    {
        title: "What we collect",
        body: "When you complete the Business Health Check or the enquiry form, we collect the details you choose to give us — typically your name, business name, email address, phone number and information about your business challenges. The Health Check can be completed anonymously; contact details are only stored if you tick the consent box.",
    },
    {
        title: "How we use it",
        body: "Your information is used only to respond to your enquiry, send you results you asked for, and prepare for a Growth Conversation. We do not sell, rent or share your details with third parties for marketing.",
    },
    {
        title: "Confidentiality",
        body: "Commercial information you share with GrowVise — in forms, assessments or conversations — is held in strict confidence. It is not disclosed outside GrowVise without your agreement.",
    },
    {
        title: "Storage and security",
        body: "Enquiry and assessment data is stored securely and accessed only to follow up with you. You can ask us at any time to correct or delete your information by emailing leo@growvise.co.nz.",
    },
    {
        title: "Analytics",
        body: "This site uses privacy-respecting product analytics to understand which pages are useful and whether enquiry forms are completed. No sensitive form content is sent to analytics tools.",
    },
];

export default function Privacy() {
    return (
        <div data-testid="privacy-page">
            <Seo
                title="Privacy Policy | GrowVise"
                description="How GrowVise collects, uses and protects the information you share through this website."
                path="/privacy"
            />
            <section className="bg-navy-950 pt-32 sm:pt-40 pb-14" data-testid="privacy-shell">
                <div className="max-w-6xl mx-auto px-5 sm:px-8">
                    <FadeUp>
                        <p className="eyebrow">Privacy</p>
                        <h1 className="mt-6 font-serif font-semibold text-white tracking-tight text-4xl sm:text-5xl" data-testid="privacy-title">
                            Privacy Policy
                        </h1>
                        <p className="mt-4 text-[11px] font-mono tracking-widest uppercase text-slate-500">GrowVise · Auckland, New Zealand · Last updated October 2026</p>
                    </FadeUp>
                </div>
            </section>
            <section className="bg-cream section-pad">
                <div className="max-w-3xl mx-auto px-5 sm:px-8">
                    <FadeUp>
                        <div className="space-y-10">
                            {SECTIONS.map((s) => (
                                <div key={s.title} className="border-t border-navy-900/10 pt-7 first:border-t-0 first:pt-0" data-testid={`privacy-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                                    <h2 className="font-serif font-semibold text-xl text-ink">{s.title}</h2>
                                    <p className="mt-3 text-warmgrey leading-relaxed">{s.body}</p>
                                </div>
                            ))}
                        </div>
                        <p className="mt-12 text-sm text-warmgrey leading-relaxed border-t border-navy-900/10 pt-8">
                            Questions about this policy? Email{" "}
                            <a href="mailto:leo@growvise.co.nz" className="text-gold-700 hover:text-gold-600 font-medium" data-testid="privacy-email-link">leo@growvise.co.nz</a>.
                        </p>
                    </FadeUp>
                </div>
            </section>
        </div>
    );
}
